export default "__VITE_ASSET__ab8965dc__"